import React from 'react'

import { formatMoney } from '@/shared/functions/String/string.functions'
import { Box, Typography } from '@mui/material'

import ResponsiveDisplayWrapper from '../../../ResponsiveDisplayWrapper/ResponsiveDisplayWrapper.component'

import styles from './SummaryRows.styles'
import { SummaryRowsProps } from './SummaryRows.types'

const SummaryRows: React.FC<SummaryRowsProps> = ({ tax, fees, discount, currency, desktopOnly = true }) => {
  const getHurrierFees = () => {
    if (fees === undefined || fees === null) return null

    return (
      <Box sx={styles.row}>
        <Typography sx={styles.fieldText}>Delivery Fees</Typography>
        <Typography sx={styles.fieldText}>{formatMoney(fees, currency)}</Typography>
      </Box>
    )
  }

  const getDiscount = () => {
    if (!discount || discount <= 0) return null

    return (
      <Box sx={styles.row}>
        <Typography sx={styles.fieldText}>Discount Applied</Typography>
        <Typography sx={styles.fieldText}>-{formatMoney(discount, currency)}</Typography>
      </Box>
    )
  }

  const getTax = () => {
    if (tax === undefined || tax === null) return null

    return (
      <Box sx={styles.row}>
        <Typography sx={styles.fieldText}>Tax</Typography>
        <Typography sx={styles.fieldText}>
          <ResponsiveDisplayWrapper isDesktop={false}>~&nbsp;</ResponsiveDisplayWrapper>
          {formatMoney(tax, currency)}
        </Typography>
      </Box>
    )
  }

  if (desktopOnly) {
    return (
      <>
        <ResponsiveDisplayWrapper isDesktop>{getTax()}</ResponsiveDisplayWrapper>
        <ResponsiveDisplayWrapper isDesktop>{getHurrierFees()}</ResponsiveDisplayWrapper>
        <ResponsiveDisplayWrapper isDesktop>{getDiscount()}</ResponsiveDisplayWrapper>
      </>
    )
  }

  return (
    <>
      {getTax()}
      {getHurrierFees()}
      {getDiscount()}
    </>
  )
}

export default SummaryRows
